import styled from 'styled-components';
import { color, themeColor } from '@whitelabel/helpers/style/colors';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { fontFamily, fontWeight, lineHeight } from '@whitelabel/helpers/style/type';

export const StyledAppLayout = styled.div<{ $isNavOpen: boolean; $rtl: boolean }>`
  direction: ${({ $rtl }) => ($rtl ? 'rtl' : 'ltr')};

  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: ${({ $isNavOpen }) => ($isNavOpen ? 'fixed' : 'initial')};

  ${mediaBreakpointUp('lg')`
    position: initial;
  `}

  main {
    background-color: ${themeColor('bgLight')};

    body.rentalcover-theme & {
      padding-top: 1rem;
      padding-bottom: 4rem;

      ${mediaBreakpointUp('sm')`
        padding-top: 2rem;
        padding-bottom: 5rem;
      `}

      ${mediaBreakpointUp('md')`
        padding-top: 3rem;
        padding-bottom: 8rem;
      `}
    }
  }

  dt {
    font-family: ${fontFamily('sanSerif')};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    text-transform: none;
  }

  .desktop-only {
    display: none;

    ${mediaBreakpointUp('lg')`
      display: flex;
    `}
  }

  .mobile-only {
    display: flex;

    ${mediaBreakpointUp('lg')`
      display: none;
    `}
  }

  .title-heading-style {
    line-height: ${lineHeight('headingsLg')};
    display: inline;
    margin-inline: 0.5rem;
    font-weight: ${fontWeight('black')};

    ${mediaBreakpointUp('sm')`
      margin-inline: 1rem;
    `}

    background: ${themeColor('secondary')};
    color: ${color('white')};
    box-decoration-break: clone;

    box-shadow: 0.5rem 0 0 ${themeColor('secondary')}, -0.5rem 0 0 ${themeColor('secondary')};

    ${mediaBreakpointUp('sm')`
      box-shadow: 1rem 0 0 ${themeColor('secondary')}, -1rem 0 0 ${themeColor('secondary')};
    `};

    text-transform: uppercase !important;
    font-size: 2rem;

    ${mediaBreakpointUp('lg')`
    font-size: 3rem;
  `}

    sup {
      font-size: 50%;
      vertical-align: super;
    }
  }
`;

export const StyledMain = styled.main<{ $shouldRemoveGap?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${themeColor('primaryBg')};
  grid-row-gap: ${({ $shouldRemoveGap }) => ($shouldRemoveGap ? '0' : '2rem')};
`;
